import React from 'react'
import { Link } from 'react-router-dom'
import ArrowToTop from '../ArrowToTop'
import ScrollToTopOnMount from '../ScrollToTopOnMount'
import URLS from '../../utils/urls'
import logo from '../../utils/czarymarry_logo.png'
import SeoContent from '../SeoContent'
import CustomPostLink from '../CustomLink/CustomPostLink'
import './styles.scss'

const APP_URL = process.env.REACT_APP_BASE_URL

const seo = {
    title: 'Oferta | konsultanci ślubni | Czary Marry',
    description: 'Wyjątkowa oferta organizacji Waszego ślubu i wesela marzeń. Poznaj propozycję konsultanta ślubnego.',
    url: `${APP_URL}${URLS.OFFER}`,
    image: logo
}

const offerDetails = [
    { color: "bgPink", number: "01", title: "Kompleksowa organizacja", text: "To całkowita pomoc w organizacji oraz wsparcie na każdym etapie planowania wesela. Zaczynając od zaplanowania budżetu, poszukiwania sali, stworzenia harmonogramu przygotowań, poprzez poszukiwanie wszystkich wykonawców, skończywszy na stworzeniu scenariusza ślubnego i koordynacji przyjęcia." },
    { color: "bgMint", number: "02", title: "Koordynacja ślubu i wesela", text: <>Będziemy do Waszej dyspozycji w dniu ślubu. Dopilnujemy, aby wszystko przebiegło tak jak to sobie zaplanowaliście, a Wam pozostawimy świętowanie. Stworzymy <CustomPostLink text="scenariusz uroczystości" path="plan-wesela-harmonogram-dnia-slubu-krok-po-kroku" className="linkDark" />, będziemy w kontakcie z wykonawcami oraz salą weselną.</> },
    { color: "bgGrey", number: "03", title: "Wybrane elementy", text: <>Potrzebujecie pomocy tylko przy części usług? To usługa stworzona specjalnie dla Was! To Wy decydujecie w jakim stopniu chcecie nas zaangażować w <CustomPostLink text="przygotowania" path="przygotowania-do-slubu-formalnosci" className="linkDark" />.</> },
    { color: "bgPink", number: "04", title: "Kurs online", text: <><Link to={URLS.COURSE} className="linkDark">Kurs online “Organizacja wesela krok po kroku” z Czary Marry</Link> pomoże Wam złapać oddech i uporządkować przygotowania w przemyślany sposób. To pierwsze szkolenie online dostępne dla par, które chcą samodzielnie zaplanować swój ślub i wesele, ale nie chcą tracić czasu na błądzenie, szukanie, zgadywanie.</> },
    { color: "bgDark", number: "05", title: "Ślubne SOS", text: "Kryzysowe i trudne sytuacje nie są dla nas niczym nowym. Nasza praca to planowanie różnych scenariuszy i rozwiązywanie niespodziewanych sytuacji. Warto w ciężkiej sytuacji zdać się na pomoc osoby doświadczonej. Pomożemy Wam ze znalezieniem nowego terminu lub miejsca, powiemy jakie macie możliwości w związku ze zmianą terminu, zrobimy aneksy do umów." }
]
const Offer = () => (
    <div className="Offer main-div">
        <ScrollToTopOnMount />
        <SeoContent {...seo} />
        <ArrowToTop />
        <div className="page-header">
            <span className="number">04</span>
            <h2 className="page-title">Oferta</h2>
        </div>
        <div className="Offer-content">
            <p className="main-header">
                Tak jak nie ma dwóch takich samych wesel, tak każda ze zgłaszających się do nas par ma inne oczekiwania i potrzeby. Każde zapytanie traktujemy indywidualnie, dlatego nie posługujemy się gotowymi rozwiązaniami oraz nie mamy sztywnego cennika usług. Wystarczy, że zadzwonisz do nas na krótką rozmowę lub umówisz się na kawę, a w ciągu 24h otrzymasz spersonalizowaną ofertę wraz z wyceną. Nie możemy się doczekać aż posłuchamy o Waszej wizji ślubu i wesela.
            </p>
            <div className="Offer-content_grid">
                {offerDetails.map(({ color, number, title, text }, index) => (
                    <div key={index} className={`grid-box ${color}`}>
                        <h3 className="num-small">{number}</h3>
                        <span>
                            <h4 className="title-small">{title}</h4>
                            <p>{text}</p>
                        </span>
                    </div>
                ))}
            </div>
        </div>
    </div>
)

export default Offer